"use strict";

export default class ObjectHelper {

	static isEquivalentArrayOfObjects(array1, array2)
	{
		if (array1.length !== array2.length) {
			return false;
		}

		for (let i = 0; i < array1.length; i++) {
			if (!this._isEquivalent(array1[i], array2[i])) {
				return false;
			}
		}

		return true;
	}

	/**
	 * Check if two objects are identical
	 * @param  {Object}  a
	 * @param  {Object}  b
	 * @return {Boolean}
	 */
	static _isEquivalent(a, b)
	{
		let aProps = Object.getOwnPropertyNames(a);
		let bProps = Object.getOwnPropertyNames(b);

		if (aProps.length !== bProps.length) {
			return false;
		}

		for (const element of aProps) {
			let propName = element;
			if (a[propName] !== b[propName]) {
				return false;
			}
		}

		return true;
	}

};
